// Centralized tooltip messages
// Edit messages here and they'll update across the app

export const TOOLTIPS: Record<string, string> = {
  // Navbar actions
  "navbar.button.collapse": "Collapse sidebar",
  "navbar.button.expand": "Expand sidebar",
  "data-scope-configurator.metric_selection.tooltip": "Choose which metrics the analyst can access",
  "data-scope-configurator.scope_related_entities.tooltip":
    "Select related metric entities that the analyst can access",
  "data-scope-configurator.attribute_values.tooltip":
    "Define specific attribute filters and constraints to further refine the analyst's data access",
  "data-scope-configurator.usage_guidelines.tooltip": "Enter guidelines or instructions for using this data scope",
  "data-scope-configurator.edit_filter_values.tooltip": "Edit filter values",
  "data-scope-configurator.show_filter.tooltip": "Show to analyst",
  "data-scope-configurator.hide_filter.tooltip": "Hide from analyst",
  "data-scope-configurator.remove_filter.tooltip": "Remove filter",
  "preset_filter.constraints.tooltip": "Define constraints for a scenario",
  "scenario_creation_component.details.tooltip": "Enter a brief description of the scenario",
  "scenario_creation_component.details.issue.tooltip": "Enter a brief description of the issue",
  "scenario_creation_component.details.trigger_conditions.tooltip":
    "Enter a brief description of the trigger conditions",
  "scenario_creation_component.details.investigation_protocol.tooltip":
    "Enter a brief description of the investigation protocol",
  "scenario_creation_component.details.reporting_instructions.tooltip":
    "Enter a brief description of the reporting instructions",
  "scenario_creation_component.details.analysis_instructions.tooltip":
    "Enter a brief description of the analysis instructions",
  "workflow_detail.objective.tooltip": "Describes the goal of this workflow.",
  "workflow_detail.schedule.tooltip": "Defines when this workflow runs automatically on a recurring schedule.",
  "workflow_detail.instructions.tooltip":
    "Describes the instructions for the analyst to follow when performing the workflow.",
  // Edit metric definition
  "edit_metric_definition.metric_type.tooltip":
    "Additive metrics can be summed directly. Complex metrics, such as ratios or formulae that cannot be aggregated.",
  "edit_metric_definition.polarity.tooltip": "Positive means higher is better; negative means lower is better.",
  "edit_metric_definition.precision.tooltip": "How many decimal places Anko uses when reporting this metric.",
  "edit_metric_definition.formula.tooltip":
    "Enter a formula for this metric. This is used to calculate the metric value.",
  // Edit KG column (attributes)
  "edit_kg_column.cardinality.tooltip":
    "Cardinality reflects how many unique values this attribute has: low for a small set of distinct values," +
    " high when there can be very many.",
  "edit_kg_column.cardinality.low_hint": "Anko remembers every distinct value",
  "edit_kg_column.cardinality.high_hint": "Anko discovers values while analyzing the data",
};

/**
 * Action verbs for the chat artifacts.
 */
export const CHAT_ACTION_VERBS = {
  analyzed: ["Analyzed", "Examined", "Reviewed", "Explored", "Studied"],
  queried: ["Queried", "Retrieved", "Fetched", "Loaded"],
  generated: ["Generated", "Created", "Produced", "Built"],
};
